export const DEFAULT_METRIC_APP = 'customer-orders'

export const METRIC_APPS: Array<{ value: string; label: string }> = [
  { value: 'customer-orders', label: 'Orders' },
  { value: 'customer-decision-center', label: 'Decision center' },
  { value: 'customer-case-search', label: 'Case search' },
  { value: 'customer-dev-tools', label: 'Dev tools' },
  { value: 'returns', label: 'Returns' },
  { value: 'insights', label: 'Insights' },
  { value: 'settings', label: 'Settings' },
  { value: 'user-admin', label: 'User admin' },
  { value: 'admin-tools', label: 'Admin tools' },
  { value: 'admin-mr-tools', label: 'MR tools' },
  { value: 'admin-claims-dashboard', label: 'Claims dashboard' },
  { value: 'federated-shell', label: 'Federated shell' },
  { value: 'federated-agent', label: 'Federated agent' },
  { value: 'federated-navbar', label: 'Federated navbar' },
]
